import React, {useEffect, useState} from 'react';
import localStorageService from '../services/localStorageService';

const Owners = () => {

    const [owners, setOwners] = useState([]);

    useEffect(() => {
        let fromStore = localStorageService.owners.get();
        if (fromStore) {
            setOwners(fromStore);
        }
    }, []);

    return (
        <div className="">
            <h3 className="mb-4">Владельцы: {owners.length}</h3>
            <table className="table table-striped table-hover">
                <thead className="table">
                    <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Полное Имя</th>
                        <th scope="col">БИН</th>
                        <th scope="col">Адрес</th>
                        <th scope="col" className="text-end">Action</th>
                    </tr>
                    <tr>
                    <th scope="col"><input type='text' className="form-control"/></th>
                        <th scope="col"><input type='text' className="form-control"/></th>
                        <th scope="col"><input type='text' className="form-control"/></th>
                        <th scope="col"><input type='text' className="form-control"/></th>
                        <th scope="col" className="text-end"></th>
                    </tr>
                </thead>
                <tbody>
                    {owners.map((row) => (
                        <tr key={row.id}>
                            <td>{row.id}</td>
                            <td>{row.name}</td>
                            <td>{row.bin}</td>
                            <td>{row.address}</td>
                            <td className="text-end">
                                {/* <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => {}}
                                >
                                    Деактивировать
                                </button> */}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default Owners;